import { RingStyleEnum } from '@/app/enums/RingStyleEnum';
import type { RingStyle } from '@/app/types/ring';
import type { Products_content_listProducts_wizard_styleStep_carouselImages } from '@/queries/types/Products';

type TempCarouselImages = Record<
  RingStyle,
  Products_content_listProducts_wizard_styleStep_carouselImages[]
>;
//TODO: GROW-1607 clean up Gen3 clean up
export const carouselImages: TempCarouselImages = {
  [RingStyleEnum.Heritage]: [
    {
      altMsgKey: 'pdp_carousel_alt_heritage_silver_video',
      mobileSrc:
        'https://s3.amazonaws.com/ouraring.com/images/product/wizard/pdp-video-heritage-silver-mobile.mp4',
      originalSrc:
        'https://s3.amazonaws.com/ouraring.com/images/product/wizard/pdp-video-heritage-silver.mp4',
      thumbnailSrc:
        'https://s3.amazonaws.com/ouraring.com/images/product/simple/pdp-video-thumb-heritage-silver.png',
      inverseText: false,
      content: null,
      originalSrcKey: null,
    },
    {
      altMsgKey: 'pdp_carousel_alt_mobile_app',
      originalSrc:
        'https://s3.amazonaws.com/ouraring.com/images/product/wizard/pdp-ring-style-app-v2.jpg',
      thumbnailSrc: 'thumbnail-pdp-slide-2',
      inverseText: true,
      originalSrcKey: 'pdp_slide_2_app_ui',
      content: null,
      mobileSrc: null,
    },
    {
      altMsgKey: 'pdp_carousel_alt_woman_sunset',
      originalSrc:
        'https://s3.amazonaws.com/ouraring.com/images/product/wizard/pdp-sizing-heritage-silver-gradient.jpg',
      thumbnailSrc: '',
      inverseText: true,
      content: null,
      mobileSrc: null,
      originalSrcKey: null,
    },
    {
      altMsgKey: 'pdp_carousel_alt_ring_closeup',
      originalSrc:
        'https://s3.amazonaws.com/ouraring.com/images/product/wizard/pdp-ring-style-ring-closeup.png',
      thumbnailSrc:
        'https://s3.amazonaws.com/ouraring.com/images/product/wizard/pdp-ring-thumb-closeup.jpg',
      inverseText: false,
      content: [
        {
          iconName: 'sensors_boxed',
          heading: 'pdp_horizon_breakthrough_sensors_title',
          copy: 'sensors_copy',
        },
        {
          iconName: 'battery_boxed',
          heading: 'pdp_highlights_battery_life',
          copy: 'seven_days_battery_copy',
        },
        {
          iconName: 'titanium_boxed',
          heading: 'pdp_highlights_titanium',
          copy: 'titanium_copy',
        },
        {
          iconName: 'water_resist_boxed',
          heading: 'pdp_highlights_water_resistant',
          copy: 'water_resistant_copy',
        },
      ],
      mobileSrc: null,
      originalSrcKey: null,
    },
  ],
  [RingStyleEnum.Horizon]: [
    {
      altMsgKey: 'pdp_carousel_alt_horizon_silver_video',
      mobileSrc:
        'https://s3.amazonaws.com/ouraring.com/images/product/wizard/pdp-video-horizon-silver-mobile.mp4',
      originalSrc:
        'https://s3.amazonaws.com/ouraring.com/images/product/wizard/pdp-video-horizon-silver.mp4',
      thumbnailSrc:
        'https://s3.amazonaws.com/ouraring.com/images/product/simple/pdp-video-thumb-horizon-silver.png',
      inverseText: false,
      content: null,
      originalSrcKey: null,
    },
    {
      altMsgKey: 'pdp_carousel_alt_mobile_app',
      originalSrc:
        'https://s3.amazonaws.com/ouraring.com/images/product/wizard/pdp-ring-style-app-v2.jpg',
      thumbnailSrc: 'thumbnail-pdp-slide-2',
      inverseText: true,
      originalSrcKey: 'pdp_slide_2_app_ui',
      content: null,
      mobileSrc: null,
    },
    {
      altMsgKey: 'pdp_carousel_alt_well_dressed_man',
      originalSrc:
        'https://s3.amazonaws.com/ouraring.com/images/product/wizard/pdp-ring-horizon-lifestyle.jpg',
      thumbnailSrc: '',
      inverseText: false,
      content: null,
      mobileSrc: null,
      originalSrcKey: null,
    },
    {
      altMsgKey: 'pdp_carousel_alt_ring_closeup',
      originalSrc:
        'https://s3.amazonaws.com/ouraring.com/images/product/wizard/pdp-ring-style-ring-closeup.png',
      thumbnailSrc:
        'https://s3.amazonaws.com/ouraring.com/images/product/wizard/pdp-ring-thumb-closeup.jpg',
      inverseText: false,
      mobileSrc: null,
      originalSrcKey: null,
      content: [
        {
          iconName: 'sensors_boxed',
          heading: 'pdp_horizon_breakthrough_sensors_title',
          copy: 'sensors_copy',
        },
        {
          iconName: 'battery_boxed',
          heading: 'pdp_highlights_battery_life',
          copy: 'seven_days_battery_copy',
        },
        {
          iconName: 'titanium_boxed',
          heading: 'pdp_highlights_titanium',
          copy: 'titanium_copy',
        },
        {
          iconName: 'water_resist_boxed',
          heading: 'pdp_highlights_water_resistant',
          copy: 'water_resistant_copy',
        },
      ],
    },
  ],
  [RingStyleEnum.OuraRing4]: [],
};
